import { Box, Stack, Typography } from "@mui/material";
import { deliveryNoteBusiness } from "api/bussiness/delivery-note/delivery-note-business";
import { downloadFile } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { ExportExcelDialog } from "share-components/mui-wrap/dialog/export-excel-dialog";
import { XTextField } from "share-components/mui-wrap/text-field/x-text-field";

export const ExportExcel = observer(() => {
  const {
    deliveryNoteManagement: {
      excelParams: {
        poDateRangeFilter: {
          fromAsDayJs,
          from,
          to,
          toAsDayJs,
          setProp: setPODateRange,
        },
        fromNumber,
        toNumber,
        setProp: setExcelParamProp,
      },
      openExportExcel,
      setProp,
    },
  } = useStores();
  const handleClose = () => {
    setProp("openExportExcel", false);
  };

  const fromPODateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setPODateRange("from", value ? value.toString() : null);
    },
    [setPODateRange]
  );

  const toPODateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setPODateRange("to", value ? value.toString() : null);
    },
    [setPODateRange]
  );

  const exportBtnDisabled = useMemo(() => {
    if (!fromAsDayJs || !toAsDayJs) {
      return true;
    }
  }, [fromAsDayJs, toAsDayJs]);

  const exportExcel = useCallback(async () => {
    try {
      const res = await deliveryNoteBusiness.exportExcel({
        fromDate: fromAsDayJs?.isValid() && from ? from : "",
        toDate: toAsDayJs?.isValid && to ? to : "",
        fromNumber: fromNumber || undefined,
        toNumber: toNumber || undefined,
      });
      downloadFile(
        res,
        `phieu_giao_hang_tu_${dateTimeDisplay(from)}_den_${dateTimeDisplay(
          to
        )}.xlsx`
      );
    } catch (ex) {
    } finally {
    }
  }, [from, fromAsDayJs, fromNumber, to, toAsDayJs?.isValid, toNumber]);
  return (
    <ExportExcelDialog
      open={openExportExcel}
      handleClose={handleClose}
      exportBtnDisabled={exportBtnDisabled}
      exportHandler={exportExcel}
    >
      <Stack direction={"column"} spacing={2}>
        <Stack direction={"row"} sx={{ paddingTop: 1 }}>
          <DateRange
            label={"Ngày Giao:"}
            fromDate={fromAsDayJs}
            toDate={toAsDayJs}
            onFromDateChanged={fromPODateChangedHandler}
            onToDateChanged={toPODateChangedHandler}
          ></DateRange>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Typography variant="subtitle2">Số phiếu:</Typography>
          <Stack direction={"row"} alignItems={"center"}>
            <XTextField
              label="Từ"
              value={fromNumber}
              onChange={(e) =>
                setExcelParamProp(
                  "fromNumber",
                  Number(e.currentTarget?.value as any)
                )
              }
              type="number"
            ></XTextField>
            <Box sx={{ paddingLeft: "5px", paddingRight: "5px" }}>-</Box>
            <XTextField
              label="Đến"
              value={toNumber}
              type="number"
              onChange={(e) =>
                setExcelParamProp(
                  "toNumber",
                  Number(e.currentTarget?.value as any)
                )
              }
            />
          </Stack>
        </Stack>
      </Stack>
    </ExportExcelDialog>
  );
});
